export default "__VITE_ASSET__DFlYmpvc__"